import { create } from 'zustand';

interface FilesGridListErrorState {
  errorNoFreeSpaceMessage: string;
  
  // Actions
  setErrorNoFreeSpaceMessage: (message: string) => void;
  
  // Clear error message
  clearErrorMessage: () => void;
}

export const useFilesGridListErrorStore = create<FilesGridListErrorState>((set) => ({
  errorNoFreeSpaceMessage: '',
  
  setErrorNoFreeSpaceMessage: (message) => set({ errorNoFreeSpaceMessage: message }),
  
  clearErrorMessage: () => set({ errorNoFreeSpaceMessage: '' }),
}));
